<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  names: string[];
}>();

const joinedNames = computed(() => props.names.join(' | '));
</script>

<template>
  <div v-if="names.length" class="assigned-scopes" :title="joinedNames">
    <div class="assigned-scopes__caption text-caption font-weight-medium text-primary-lighten-1">
      {{ $t('EvaluationScope') }}
    </div>
    <div class="text-body-2 font-weight-semibold text-primary-darken-2 text-no-wrap">
      {{ joinedNames }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.assigned-scopes {
  flex: 0 0 auto;
}

.assigned-scopes__caption {
  // The panel title sets line-height: 1.
  line-height: 1.4;
}
</style>
